
import React, { Suspense, lazy , useRef ,  useState, useContext , useEffect } from "react";
import { Link , useNavigate } from "react-router-dom";
import  logo  from "../assets/web/images/logo.png";
import  design1  from "../assets/web/images/design-1.png";
import  design2  from "../assets/web/images/design-2.png";
import  bg  from "../assets/web/images/ivo-bg.png";
import { WebAssetsContext } from "../App";
import { alertDanger } from "../functions/Function";
const Webassetscss = React.lazy(() => import('../Webassets'));
const Signin = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [inputs, setInputs] = useState({});
  const [validation, setValidation] = useState(null);
  const [alert, setAlert] = useState(null);
 
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({ ...values, [name]: value }))
  }
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);
    try {
      let res = await fetch(api + "signin", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputs),
      });
      let output = await res.json();
    
      setDisabled(false);
      if (res.status === 200) {
        setAlert(null)
        setValidation(null)
        if(output.result == true)
        {
          let user = {
            'token' : output.response.id,
            'user' : output.response,
          }
          localStorage.setItem("customer", JSON.stringify(user));
          props.customerInAdmin();

        }else
        {
          if(output.validation == true)
          {
            setValidation(output.response)
          }else
          {
            setAlert(alertDanger(output.response));
          }
        }

      }
    } catch (err) {
      setDisabled(false);
    }
  }
  return (
    <>
    
     <Suspense>
      <Webassetscss />
      <section style={{
      backgroundImage: `url("${bg}")`
    }} className="ivo-section ivo-login-page">
        <div className="ivo-design-2">
          <img className="img-fluid" src={design1} alt="d-1" />
        </div>
        <div className="container">
          <div className="ivo-shadow-box ivo-login-box ivo-ovrflow-hidden">
            <div className="ivo-external-heading text-center">
              <div className="ivo-logo">
                <Link to="/"> <img className="img-fluid" src={logo} /></Link>
              </div>
              <h5 className="ivo-before-login-heading">
                Login to Ivoire

              </h5>
            </div>
            <hr />
            {alert}
             
              <form method="POST" onSubmit={handleSubmit}>
                
              <div className="ivo-login-middle">
              
                  <div className="form-group">
                    <label>Email / Mobile</label>
                    <input
                      type="text"
                      name="email"
                      value={inputs.email || ""}
                      onChange={handleChange}
                      placeholder="Enter Your Email OR Mobile Number"
                      className="form-control"
                    />
                     {validation != null && validation.email != '' ?  <p className="erAlert text-danger ">{validation.email}</p> : ''} 
                  </div>
                  <div className="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      name="password"
                      value={inputs.password || ""}
                      onChange={handleChange}
                      placeholder="Enter Your Password"
                      className="form-control"
                    />
                   
                   {validation != null && validation.password != '' ?  <p className="erAlert text-danger  ">{validation.password}</p> : ''} 
                  </div>
               
              </div>
              <hr />
                <div className="ivo-login-footer">
                  
                  <button className="btn ivo-site-btn" type="submit" disabled={disabled}> {disabled == false ? 'Login' : 'Logining...'} </button>
                  <div className="ivo-login-links">
                    <Link to="/signup">Create your new account ?</Link>
                    <Link to="/forgotpassword">Forgot Password?</Link>
                  </div>
                </div>
              </form>


              </div>



          </div>
          <div className="ivo-design-1">
            <img className="img-fluid" src={design2} alt="d-2" />
          </div>
      </section>

      

     
      </Suspense>
    </>

  );
}

export default Signin;
